export enum RelayScriptRuleModifier {
  NONE = 'NONE',
  ORDER_EXISTS = 'ORDER_EXISTS',
  ORDER_DOESNT_EXIST = 'ORDER_DOESNT_EXIST'
}
